import { Button, Select } from 'antd';
import SelectItem from '@/app/product/TypeSelection/item';
import {
  CurrentTypeSelect,
  ProductSkuType,
  ProductTypeSelection,
} from '@/lib/type/product.type';
import { useMemo } from 'react';
import { requestGetAvailableSpecValues } from '@/lib/api/product';
import clsx from 'clsx';

type Props = {
  spec_format?: ProductTypeSelection[];
  sku?: ProductSkuType[];
  selectAction?: (data: boolean) => void;
  selectTypeAction?: (data: ProductSkuType) => void;
  product: any;
  changesetT3dUrl: (str: string) => void;
  types: string[];
  embedPartNumberData: any
  changeEmbedPartNumberData: (data: any) => void
  resetEmbedPartNumberData: () => void
};

export default function TypeSelection(props: Props) {
  //选中的数据
  const embedPartNumberData = props.embedPartNumberData;
  //重置选中的数据
  const resetEmbedPartNumberData = props.resetEmbedPartNumberData;
  //修改选中的数据
  const changeEmbedPartNumberData = props.changeEmbedPartNumberData;
  const product = props.product;
  const sku = product?.sku;
  const newSku = useMemo(() => {
    if (!sku?.length) return [];
    return sku.map((item: any) => ({
      value: item?.name,
      label: item?.name,
    }));
  }, [sku]);

  return (
    <>
      <div className="flex items-center my-4">
        <div className="c-flex">
          <div className="flex items-center">
            <span className="text-lg font-bold flex-shrink-0">
              产品型号：
            </span>
            <div className="s-flex flex-wrap ">
              <div className="flex items-center product border mr-4 border-[#999]">
                <Select

                  value={embedPartNumberData?.name}
                  onChange={(value) => {
                    changeEmbedPartNumberData(value);
                  }}
                  placeholder={
                    <span>
                      有{' '}
                      <span className="text-main">{newSku.length}</span>{' '}
                      个型号
                    </span>
                  }
                  style={{ width: 200 }}
                  options={newSku}
                />
   
              </div>
              <Button  onClick={resetEmbedPartNumberData}>重置</Button>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8">
        {embedPartNumberData?.name ? (
          <>
            <div className="">
              <p className="font-bold text-lg mb-4">
                <span>单价：</span>
                <span className="text-main">{embedPartNumberData?.price}</span>
              </p>
              <div className="bg-[#fef3f0] border-dashed border-main border p-4 grid grid-cols-1">
                <div>
                  <div>
                    <span>未税单价：</span>
                    <span className="text-main text-lg font-bold">
                      -{embedPartNumberData?.price}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="flex items-center mt-4">
                    <span>发货天数：</span>
                    <p className="text-main text-lg font-bold border-b border-[#999] px-2">
                      5 - 7
                    </p>
                    <span>发货天数以下单次日起算，不含周日与法定假日</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="">
              <h3 className="flex items-center text-[#ee0505] mb-4">
                <i className="ri-error-warning-fill mr-2"></i>
                <span>请选择或填写完整型号参数来生成产品型号!</span>
              </h3>
              <div className="bg-[#fef3f0] border-dashed border-main border p-4 grid grid-cols-1">
                <div>
                  <div>
                    <span>未税单价：</span>
                    <span className="text-main text-lg font-bold">-</span>
                  </div>
                </div>
                <div className="">
                  <div className="flex items-center mt-4">
                    <span>发货天数：</span>
                    <p className="text-main text-lg font-bold border-b border-[#999] px-2">
                      -
                    </p>
                    <span>发货天数以下单次日起算，不含周日与法定假日</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
